import * as yup from 'yup';

export const topicValidationSchema = yup.object().shape({
  name: yup.string().required( 'El nombre es requerido' ),
  url: yup.string().url( 'El formato debe ser de tipo URL' ).required( 'La url es requerida' ),
});
